import { loadingAsyncState } from "widgets-for-react";
import { getBlogs } from "./blogOverviewApi";
export const blogCategories = [
    'cultuur',
    'inspiratie',
    'leren',
    'almere'
];
export const labels = {
    'cultuur': 'Cultuur',
    'inspiratie': 'Inspiratie',
    'leren': 'Leren',
    'almere': 'Almere'
};
export const initialBlogResponse = {
    totalResults: 0,
    posts: []
};
export const initialState = (props)=>({
        blogpostLoader: loadingAsyncState(getBlogs(1, props.pageSize, null), initialBlogResponse),
        currentPage: 1,
        selectedCategory: null
    });
export const resultsClass = "blog-results";
